import React from "react";

import Grid from "@mui/material/Grid";

const ScrollableGrid = (props: { children?: React.ReactNode }) => (
    <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{
            display: "flex",
            height: "auto",
            flexWrap: "wrap",
            rowGap: 1,
            width: "100%",
            maxHeight: { md: "620px" },
            overflow: { md: "auto" },
            paddingLeft: { md: 0.25 },
            paddingBottom: { md: 0.25 },
        }}
    >
        {props.children}
    </Grid>
);

export default ScrollableGrid;
